import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'

export const Route = createFileRoute('/_app/roles')({
  staticData: { crumb: 'roles' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'roles.read'),
  component: Outlet,
})
